const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Content Inner Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('contentInnerViewer', ['Application', 'Authorization', function (Application, Authorization) {
  return {
    restrict: 'E',
    scope: {
      item: '=',
      trackId: '@',
      nextForQuiz: '&'
    },
    template: require('../../templates/directives/content-inner-viewer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var user = Authorization.getAuthToken().user;
      self.getError = Application.notifications.getError;
      self.getSuccess = Application.notifications.getSuccess;

      self.type = $scope.item.article ? 'article' : $scope.item.file ? 'file' : $scope.item.video ? 'video' : $scope.item.quiz ? 'quiz' : null;
      self.data = $scope.item[self.type];

      self.nextForQuiz = function(course, next) {
        $scope.nextForQuiz({course: course, next: next})
      };

    }],
    controllerAs: 'contentViewer'
  };
}]);